import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import Organization from '../models/organization/organization.model';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() {
  }

  encryptUsingAES256(organization: Organization, text: string): any {
    const key = CryptoJS.enc.Utf8.parse(organization.cryptoKey);
    const iv = CryptoJS.enc.Utf8.parse(organization.cryptoIv);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  decryptUsingAES256(organization: Organization, decString: string): string {
    const key = CryptoJS.enc.Utf8.parse(organization.cryptoKey);
    const iv = CryptoJS.enc.Utf8.parse(organization.cryptoIv);
    const decrypted = CryptoJS.AES.decrypt(decString, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
